module.exports = __webpack_public_path__ + "img/product-shot_08_loading.2f03d97b.jpg";